// Lista LL (Adnéia, 29/10/2026): os tickets "Aguardando Seller" do portal da LL Loyalty, que o
// analista importa de manhã. A regra de quem abre atendimento fica no backend (routes/lista_ll.py);
// aqui só o que a janela mostra.

export const SITUACOES = {
  ja_tinha: { rotulo: 'Já tinha atendimento', cor: 'text-slate-600 dark:text-slate-300' },
  ja_tinha_entrega: { rotulo: 'Já tinha atendimento (pela entrega)', cor: 'text-slate-600 dark:text-slate-300' },
  aberto: { rotulo: 'Aberto agora', cor: 'text-emerald-700 dark:text-emerald-400 font-semibold' },
  aberto_sem_entrega: { rotulo: 'Aberto agora: Falha Integração (sem entrega)', cor: 'text-amber-700 dark:text-amber-400 font-semibold' },
  nao_abriu: { rotulo: 'Não abriu', cor: 'text-red-700 dark:text-red-400 font-semibold' },
};

export function rotuloSituacao(situacao) {
  return (SITUACOES[situacao] || { rotulo: situacao || '?' }).rotulo;
}

export function corSituacao(situacao) {
  return (SITUACOES[situacao] || { cor: '' }).cor;
}

// "05/11/2026, 09:36:00" (como o portal escreve) → Date; o que não reconhece, null.
export function dataDoPortal(texto) {
  const m = String(texto || '').match(/^(\d{2})\/(\d{2})\/(\d{4})(?:,?\s+(\d{2}):(\d{2})(?::(\d{2}))?)?/);
  if (!m) return null;
  const [, d, mes, a, h = '00', min = '00', s = '00'] = m;
  return new Date(Number(a), Number(mes) - 1, Number(d), Number(h), Number(min), Number(s));
}

export function prazoVencido(prazo, agora = new Date()) {
  const p = dataDoPortal(prazo);
  return !!p && p.getTime() < agora.getTime();
}

export function resumoLista(tickets) {
  const lista = Array.isArray(tickets) ? tickets : [];
  const conta = s => lista.filter(t => t.situacao === s).length;
  return {
    total: lista.length,
    conferidos: lista.filter(t => t.conferido).length,
    abertos: conta('aberto') + conta('aberto_sem_entrega'),
    sem_entrega: conta('aberto_sem_entrega'),
    ja_tinham: conta('ja_tinha') + conta('ja_tinha_entrega'),
    nao_abriu: conta('nao_abriu'),
  };
}

// O motivo do atendimento como está agora; encerrado aparece escrito.
export function motivoAgora(t) {
  if (!t || !t.id_atendimento) return '-';
  const motivo = t.motivo_pendencia || '?';
  return t.pendente === false ? `${motivo} (encerrado)` : motivo;
}

// Importa 1 vez por dia; de novo, só o admin (palavra da Adnéia, 29/10).
export function podeImportar(lista, user) {
  if (!lista || !lista.importada) return true;
  return !!user && user.role === 'admin';
}
